// extracted by mini-css-extract-plugin
export default {"chart":"NewCustomer_chart__qRu8L","legend":"NewCustomer_legend__yFgyk","indicator":"NewCustomer_indicator__UVxqm","color":"NewCustomer_color__EQ6al"};